import getMounth from '@/utils/getDate/getMounth'
import urls from '@/utils/urls/urls'
import Link from 'next/link'
import React from 'react'

const BlogCard = ({ item }: { item: any }) => {
    return (
        <div className="blog-item wow blog-card-align fadeInUp" data-wow-delay=".25s">
            <div className="blog-item-img">
                <img src={`${urls?.image}${item?.blog_img}`} alt="Thumb" />
            </div>
            <div className="blog-date">
                <strong>{!!item?.blog_date && item?.blog_date.split("-")[2]}</strong>
                <span>{getMounth(item?.blog_date && item?.blog_date.split("-")[1])}</span>
            </div>
            <div className="blog-item-info">
                <div className="blog-item-meta">
                    <ul>
                        <li>
                            <Link href={`/blogs`}>
                                <i className="fas fa-tags" /> {item?.blog_category?.map((item: any) => item?.title)}
                            </Link>
                        </li>
                        {/* <li>
                                                        <Link href="#">
                                                            <i className="far fa-comments" /> 2.5k Comments
                                                        </Link>
                                                    </li> */}
                    </ul>
                </div>
                <h4 className="blog-title">
                    <Link href={`/blogs/${item?.id}`}>
                        {item?.title}
                    </Link>
                </h4>
                <p>
                    {item?.short_description}
                </p>
                <Link className="theme-btn" href={`/blogs/${item?.id}`}>
                    Read More
                    <i className="fas fa-arrow-right" />
                </Link>
            </div>
        </div>
    )
}

export default BlogCard
